export default {
  state: {
    updates: [
      {
        title: 'ACME’s Response to Okta Breach',
        date: `${new Date().getDate()}/${new Date().getMonth()+1}/${new Date().getFullYear()}`,
        content:
          "While ACME is a fun company, we don’t play around when it comes to security and privacy. Trust is one of our core watchwords and we hold our responsibility as protectors of our customers' information in the highest regard.  ACME was NOT one of the impacted customers of the Okta breach.  Below is some additional information regarding the background, cause, and remediation steps we took regarding the Okta breach in order to maintain the trust you have in our company.",
      },
      {
        title: 'ACME’s Response to Log4j',
        date: `${new Date().getDate()}/${new Date().getMonth()+1}/${new Date().getFullYear()}`,
        content:
          "ACME did NOT find any indicators of compromise that would indicate a successful attack of our systems.  Below is some additional information regarding the background, cause, and remediation steps we took regarding the Log4j vulnerability in order to maintain the trust you have in our company.",
      },
      {
        title: 'ACME’s Response to Palo Alto DoS Vulnerability',
        date: `${new Date().getDate()}/${new Date().getMonth()+1}/${new Date().getFullYear()}`,
        content:
          'ACME does not use any Palo Alto services to deliver our product, and are not affected by this vulnerability.\n Palo Alto DoS Vulnerability Background\nTo learn more on the background of the vulnerability: https://security.paloaltonetworks.com/CVE-2022-0028',
      },
      {
        title: "Welcome to ACME's Security Trust Center",
        date: `${new Date().getDate()}/${new Date().getMonth()+1}/${new Date().getFullYear()}`,
        content:
          'As an organization that is security conscious and values security, we are excited to announce the official launch of the ACME Security Trust Center. By using this portal, you can request access to our compliance documents, review our standardized questionnaires such as the SIG and gain a general understanding of our security posture. Over time, our team will be making changes to this portal as we implement new tools and processes in our environment. You can use the Subscribe button to receive email notifications for when our team has an important update, such as if we have an updated compliance report or if we have a status update regarding a major security vulnerability that has been recently discovered. -The ACME Security Compliance Team.',
      },
    ],
  },
  mutations: {},

  getters: {
    GET_UPDATES(state) {
      return state.updates
    },
  },
}
